module.exports = __webpack_public_path__ + "fonts/Monotype  - Neue Plak Bold.74b4565.ttf";